module.exports = __webpack_public_path__ + "static/img/digital_bg_h5.e3703ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/digital_bg_h5.png
// module id = yI37
// module chunks = 34